import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Layout from './Components/Layout';
import ProtectedRoute from './Components/ProtectedRoute';
import PublicRoute from './Components/PublicRoute';
import Login from './Screens/Login';
import Dashboard from './Screens/Dashboard';
import Forget from './Screens/Forget';
import Reset from './Screens/Reset';
import Profile from "./Screens/Profile";
import Invite from "./Screens/Invite";
import Subscription from "./Screens/Subscription";
import Category from "./Screens/Category";
import CategoryView from "./Screens/CategoryView";
import SubscriptionView from "./Screens/SubscriptionView";
import Content from "./Screens/Content";
import ContentCreate from "./Screens/ContentCreate";
import ContentView from "./Screens/ContentView";
import ContentEdit from "./Screens/ContentEdit";
import CustomerMaster from "./Screens/CustomerMaster";
import CustomerMasterCreate from "./Screens/CustomerMasterCreate";
import CustomerMasterView from "./Screens/CustomerMasterView";
import CustomerMasterEdit from "./Screens/CustomerMasterEdit";
import UserReport from "./Screens/UserReport";
import LeadsReport from "./Screens/LeadsReport";
import CategoryInterestedUser from "./Screens/CategoryInterestedUser";
import Privacy from "./Components/Privacy";
import Terms from "./Components/Terms";
import AccountDeletion from "./Components/DeleteAccount";
import PasswordReset from "./Screens/PassowordRest";
import Role from "./Screens/Role";
import RoleAdd from "./Screens/RoleAdd"
import RoleEdit from "./Screens/RoleEdit"
import UserReportEdit from "./Screens/UserReportEdit";
import Payment from"./Screens/Payment";
import PaymentView from "./Screens/PaymentView";
import Refund from "./Components/Refund";
import Cancellation from "./Components/Cancellation";


function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/forget" element={<PublicRoute><Forget /></PublicRoute>} />
        <Route path="/reset-password" element={<PublicRoute><PasswordReset/></PublicRoute>} />
        <Route path="/accept-user-invite" element={<PublicRoute><Reset /></PublicRoute>} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/cancellation" element={<Cancellation />} />
        <Route path="/delete-account" element={<AccountDeletion />} />

        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/category" element={<Category />} /> 
          <Route path="/subscription/:id" element={<SubscriptionView />} />
          <Route path="/category-view/:id" element={<CategoryView />} /> 
          <Route path="/content" element={<Content />} />
          <Route path="/content-create" element={<ContentCreate />} />
          <Route path="/content-view/:id" element={<ContentView />} />
          <Route path="/content-edit/:id" element={<ContentEdit />} />
          <Route path="/customer-master" element={<CustomerMaster />} />
          <Route path="/customer-master-create" element={<CustomerMasterCreate />} />
          <Route path="/customer-master-view/:id" element={<CustomerMasterView />} />
          <Route path="/customer-master-edit/:id" element={<CustomerMasterEdit />} />
          <Route path="/user-report" element={<UserReport />} />
          <Route path="/user-report/:id" element={<UserReportEdit />} />
          <Route path="/leads-report" element={<LeadsReport />} />
          <Route path="/interested-user" element={<CategoryInterestedUser />} /> 
          <Route path="/role" element={<Role />} /> 
          <Route path="/role-create" element={< RoleAdd/>} />
          <Route path="/role-edit/:id" element={<RoleEdit />} />
          <Route path="/payment" element={<Payment/>}/>
          <Route path="/payment-view/:id" element={<PaymentView/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
